import templateUrl from './edit-claim.component.html';
import { EditClaimPermissionModal } from './edit-claim-permission-modal.component';

export const EditClaimComponent = {
    templateUrl,
    controller: class ClaimsController {
        constructor(utilityService, permissionGrantService, $state, $uibModal) {
            'ngInject'

            this.utilityService = utilityService;
            this.permissionGrantService = permissionGrantService;
            this.$state = $state;
            this.$uibModal = $uibModal;
        }
        $onInit() {
            this.filters = {};
            this.filteredClaimPermissionList = this.claimPermissionList;
            this.claimType = this.claimValues.claimType;
            this.claimValue = this.claimValues.claimValue;
            this.backUrl = "admin/roles/" + this.claimValue;
        }

        loadClaimPermissions() {
            this.$state.reload();
        }

        onGoBack() {
            window.history.go(-1);
        }

        onAddUserPermission({ key } = { key: null }) {
            this._showEditPermissionModal({
                Key: key,
                Value: true
            });
        }

        onUpdateClaimPermission(claimPermission) {
            const grant = {
                Key: claimPermission.permission.Description.Key,
                Value: claimPermission.permission.Value
            };
            this._showEditPermissionModal(grant);
        }

        onDeleteUserPermission({ key }) {
            if (!confirm("The permission override will be deleted immediately.")) {
                return;
            }
            const deleting = this.permissionGrantService
                .clearClaimPermissionGrant(this.claimType, this.claimValue, key);
            this.utilityService.showLoadingUntilResolved(
                this.utilityService.alertOnError(deleting, "Deleting permission grant failed")
            );
            deleting.then(() => {
                this.claimPermissionList = this.claimPermissionList.filter(p => p.Description.Key !== key);
                this.$state.reload();
            });
        }

        _showEditPermissionModal(permissionGrant) {
            this.$uibModal.open({
                ...EditClaimPermissionModal,
                resolve: {
                    claimType: () => this.claimType,
                    claimValue: () => this.claimValue,
                    permissionGrant: () => permissionGrant,
                    permissionDescriptions: () => this.permissionDescriptions
                }
            }).result
                .then(({ permissionGrant }) => {
                    this.$state.reload();
                })
                .catch(ex => {
                    if (ex && (ex === "cancel" || ex.$value === "cancel")) {
                        return;
                    }
                    console.error(ex);
                })
        }

    },
    controllerAs: "vm",
    bindings: {
        claimPermissionList: "<",
        claimValues: "<",
        permissionDescriptions: "<"
    }
};
